<template>
  <div>
    <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />

    <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="DOCUMENTS" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">DOCUMENTS</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.supportdoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div :style="{
      height: otheropen ? '400px' : '180px',
      overflow: 'auto',
      'overflow-x': 'hidden',
    }">
          <div class="col-lg-12">
            <el-table :data="allfilename" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Job Supporting Documents" :min-width="350" prop="filename" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope" style="height: 20px" align="left">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <div v-if="otheropen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div :style="{
      height: quoopen ? '400px' : '180px',
      overflow: 'auto',
      'overflow-x': 'hidden',
    }">
          <div class="col-lg-12">
            <el-table :data="allquodocname" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Quotation Supporting Documents" :min-width="350" prop="filename" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope" style="height: 20px" align="left">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <div v-if="quoopen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>
    <!-- add -->
    <div v-if="!submitted">
      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>JOB REQUEST SUCCESSFULLY SUBMITTED</h1>
            <p>
              Our Customer Relations Officer will be in touch with you within 24
              hours
            </p>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.drafted" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>JOB REQUEST SUCCESSFULLY DRAFTED</h1>
            <p>
              Our Customer Relations Officer will be in touch with you within 24
              hours
            </p>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.warningsubmit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">Please fill in all the forms.</div>
        </div>
      </modal>

      <div v-if="submit == false" class="row">
        <!-- job details -->
        <div class="col-lg-4 d-flex">
          <card style="
              box-shadow: none;
              color: #A5A5A5;
              padding: 0px 0px 30px 30px;

              background-color: white;
            ">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 490px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">
                Service Location <span style="color: #EC1B23">*</span>
              </p>
              <el-select class="select-info tab select-width" popper-class="custom-dropdown" placeholder="Select"
                v-model="selects.location" style="width: 90%; border-bottom: 1px solid lightgray">
                <el-option v-for="option in selects.locations" class="select-info custom-option" :value="option.value"
                  :label="option.label" :key="option.value"></el-option>
              </el-select>

              <p class="new-title" v-if="selects.collections.length != 0">
                Service Location Collection <span style="color: #EC1B23">*</span>
              </p>
              <el-select v-if="selects.collections.length != 0" class="select-info tab select-width"
                popper-class="custom-dropdown" placeholder="Select" v-model="selects.collection"
                style="width: 90%; border-bottom: 1px solid lightgray">
                <el-option v-for="option in selects.collections" class="select-info custom-option" :value="option.value"
                  :label="option.label" :key="option.value"></el-option>
              </el-select>

              <div v-if="selects.location == '3'" style="padding-right: 30px; padding-top: 20px">
                <input type="text" v-model="specify" :class="{ 'custom-input': true }" />
              </div>

              <p class="new-title">
                PIC Full Name <span style="color: #EC1B23">*</span>
              </p>

              <el-select class="select-info tab select-width" popper-class="custom-dropdown" placeholder="Select"
                v-model="selects.pic" style="width: 90%; border-bottom: 1px solid lightgray">
                <el-option v-for="option in selects.pics" class="select-info custom-option" :value="option.value"
                  :label="option.label" :key="option.value"></el-option>
              </el-select>

              <p class="new-title">PIC Phone No.</p>
              <p class="subtitle">
                {{ phoneno }}
              </p>

              <p class="new-title">PIC Fax No.</p>
              <p class="subtitle">
                {{ faxno }}
              </p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">
                {{ email }}
              </p>
            </div>
          </card>
        </div>
        <!-- waste details -->
        <div class="col-lg-8 d-flex">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>
            </div>
            <div id="tableku" v-if="this.load == false" style="height: 500px; overflow: auto; overflow-x: hidden">
              <div class="row">
                <div class="col-lg">
                  <el-table :data="tableDatas" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p style="color: #707070">
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="300" align="center" prop="wastetype" label="WASTE TYPE">
                      <div slot-scope="scope">
                        <div class="row">
                          <!-- <div class="col-lg"> -->
                          <div style="position: relative">
                            <span style="
                                color: #EC1B23;
                                position: absolute;
                                bottom: 17%;
                                right: 0;
                              ">*</span>
                            <el-select class="select-info tab select-width" placeholder="Select waste type"
                              popper-class="custom-dropdown" v-model="scope.row.wastetype" style="" @change="
      getSWCode(scope.row.wastetype, scope.$index)
      ">
                              <el-option v-for="option in selects.wastetypes" style="
                                  width: 300px;
                                  height: auto;
                                  white-space: normal;
                                " class="select-info custom-option" :value="option.value" :label="option.label"
                                :key="option.value"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="row" v-if="scope.row.nickname == 'schedule_waste'">
                          <!-- <div class="col-lg"> -->
                          <div style="position: relative">
                            <span style="
                                color: #EC1B23;
                                position: absolute;
                                bottom: 17%;
                                right: 0;
                              ">*</span>
                            <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                              placeholder="Select SW code" v-model="scope.row.swcode">
                              <el-option v-for="option in scope.row.swcodes" class="select-info custom-option"
                                :value="option.value" :label="option.label" :key="option.value" style="
                                  width: 300px;
                                  height: auto;
                                  white-space: normal;
                                "></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="row" v-if="scope.row.nickname == 'tyre'">
                          <!-- <div class="col-lg"> -->
                          <div style="position: relative">
                            <span style="
                                color: #EC1B23;
                                position: absolute;
                                bottom: 17%;
                                right: 0;
                              ">*</span>
                            <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                              placeholder="Select Tyre Type" v-model="scope.row.swcode">
                              <el-option v-for="option in scope.row.swcodes" class="select-info custom-option"
                                :value="option.value" :label="option.label" :key="option.value" style="
                                  width: 300px;
                                  height: auto;
                                  white-space: normal;
                                "></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div v-if="scope.row.nickname == 'others'" style="" align="left" class="row">
                          <div class="col-lg">
                            <input type="text" v-model="scope.row.specifywastetype" :class="{ 'custom-input': true }"
                              @input="handleInput(scope.row.specifywastetype)" />
                            <p v-if="scope.row.buttonadd === true" @click="
      handleSpecify(
        scope.row.specifywastetype,
        scope.row
      )
      " style="
                                text-align: right;
                                color: #358CCB;
                                cursor: pointer;
                              " class="link">
                              + Add new waste type
                              <span style="color: #EC1B23">*</span>
                            </p>
                          </div>
                        </div>

                        <!-- <div class="row">
                      <div class="col-lg">
                        <el-select v-if="scope.row.nickname == 'schedule_waste' ||
      scope.row.nickname == 'others' ||
      scope.row.nickname == 'garbage' ||
      scope.row.nickname == 'scrap'
      " class="select-info tab select-width" popper-class="custom-dropdown" placeholder="Select packaging type"
                          v-model="scope.row.packaging" style="" @change="getType2(scope.row)">
                          <el-option v-for="option in selects.packagings" class="select-info custom-option"
                            :value="option.value" :label="option.label" :key="option.value"></el-option>
                        </el-select>
                      </div>
                    </div> -->

                        <div style="" align="left" class="row">
                          <div class="col-lg">
                            <p style="color: #959595">
                              Waste Origin <span style="color: #EC1B23">*</span>
                            </p>
                            <input type="text" v-model="scope.row.wasteorigin" :class="{ 'custom-input': true }" />
                          </div>
                        </div>
                        <!-- v-if="
                        scope.row.nickname == 'tyre' ||
                        scope.row.nickname == 'scrap'
                      " -->
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #959595">
                                  Please upload the waste to be
                                  collected
                                  <span style="color: #EC1B23">*</span>
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-3">
                                <label :for="scope.$index + 'io'">
                                  <img src="@/assets/img/upload.png" width="73" height="40" />
                                </label>
                                <input accept="image/*" :id="scope.$index + 'io'" type="file" ref="imageupload"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  @change="
      onImagesChange(
        $event,
        scope.$index,
        scope.row.nickname
      )
      " />
                              </div>

                              <div class="col-lg-3" v-for="(item, index) in scope.row.images" :key="index">
                                <img :src="item.url" width="73" height="45" />
                                <div style="position: absolute; right: 20%; top: 0">
                                  <base-button class="btn-icon btn-cancel btn-round btn-xs"
                                    @click="deleteimage(scope.$index, index)"><i class="fa fa-times"
                                      aria-hidden="true"></i></base-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #EC1B23">{{ imgmsg }}</p>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column v-if="wastecomp != 'show'" :min-width="150" align="center" prop="wasteComponents"
                      label="WASTE COMPONENT">
                      <div slot-scope="scope">
                        <!-- v-for="(aa, index) in scope.row.wasteComponents"
                          :key="index" -->
                        <div class="row" v-if="scope.row.nickname != 'tyre'"
                          v-for="(item, index) in scope.row.wasteComponents" :key="index">
                          <div class="col-lg-9 text-right">
                            <input type="text" v-model="item.component_name" :class="{ 'custom-input': true }" />
                          </div>
                          <div class="col-lg-3 text-left" style="padding-top: 3%; right: 30px">
                            <base-button class="btn-cancel btn-link" @click="deletecomponent(scope.$index, index)"><i
                                class="tim-icons icon-simple-remove"></i></base-button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p v-if="scope.row.nickname != 'tyre'" @click="addWasteComponent(scope.$index)"
                              style="color: #358CCB; cursor: pointer" class="link">
                              + Add
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="150" align="center" prop="estqty" label="EST. QTY.">
                      <div slot-scope="{ row }">
                        <div align="center">
                          <div class="row">
                            <div class="col-lg-6">
                              <div style="width: 100%" align="left">
                                <input type="number" v-model="row.estqty" :class="{ 'custom-input': true }" step="0.01"
                                  min="0.00" />
                              </div>
                            </div>
                            <div class="col-lg-6 text-left">
                              <div class="row">
                                <div style="position: relative">
                                  <span style="
                                      color: #EC1B23;
                                      position: absolute;
                                      bottom: 17%;
                                      right: 0;
                                    ">*</span>
                                  <el-select v-if="row.nickname != 'tyre'" class="select-info tab select-width"
                                    placeholder="Select unit" v-model="row.measurement" style="width: 100%">
                                    <el-option v-for="option in selects.measurements" class="select-info custom-option"
                                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                                  </el-select>
                                </div>
                              </div>

                              <p style="color: #959595" v-if="row.nickname == 'tyre'">
                                Unit
                              </p>
                            </div>
                          </div>

                          <!-- <div class="row">
                      <div class="col-lg">
                        <el-select v-if="row.nickname == 'schedule_waste' ||
      row.nickname == 'others' ||
      row.nickname == 'garbage' ||
      row.nickname == 'scrap'
      " class="select-info tab select-width" popper-class="custom-dropdown" placeholder="Select packaging type"
                          v-model="row.packaging" style="" @change="getType2(row)">
                          <el-option v-for="option in selects.packagings" class="select-info custom-option"
                            :value="option.value" :label="option.label" :key="option.value"></el-option>
                        </el-select>
                      </div>
                    </div> -->

                          <div class="row">
                            <div class="col-lg-6">
                              <div style="width: 100%" align="left">
                                <input v-if="row.nickname != 'tyre'" type="number" v-model="row.estqtyy" step="0.01"
                                  min="0.00" :class="{ 'custom-input': true }" />
                              </div>
                            </div>
                            <div class="col-lg-6 text-left">
                              <!-- {{ row.packagingname }} -->

                              <div class="row">
                                <div style="position: relative">
                                  <span v-if="row.nickname == 'schedule_waste' ||
      row.nickname == 'others' ||
      row.nickname == 'garbage' ||
      row.nickname == 'scrap'
      " style="
                                      color: #EC1B23;
                                      position: absolute;
                                      bottom: 17%;
                                      right: 0;
                                    ">*</span>
                                  <el-select v-if="row.nickname == 'schedule_waste' ||
      row.nickname == 'others' ||
      row.nickname == 'garbage' ||
      row.nickname == 'scrap'
      " class="select-info tab select-width" popper-class="custom-dropdown" placeholder="Select packaging type"
                                    v-model="row.packaging" style="" @change="getType2(row)">
                                    <el-option v-for="option in selects.packagings" class="select-info custom-option"
                                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="120" align="center" prop="remarks" label="REMARKS">
                      <div slot-scope="{ row }">
                        <input type="text" v-model="row.remarks" :class="{ 'custom-input': true }" />
                      </div>
                    </el-table-column>
                    <el-table-column width="50" align="center" prop="delete" label="">
                      <div slot-scope="scope">
                        <i v-if="scope.$index != 0" style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: #ff0000;
                            font-size: 15px;
                            font-weight: 900;
                            cursor: pointer;
                          " @click="getDeleteRow(scope.$index)" class="tim-icons icon-trash-simple"></i>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="row text-right">
              <div class="col-lg" v-if="wastetype != 'noshow'">
                <p @click="addRow()" style="color: #358CCB; cursor: pointer" class="link">
                  + Add row
                </p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div v-if="submit == true" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">WCO</p>

            <p class="subtitle">Edit WCO</p>
            <!-- turn submit into false-->
            <base-button type="primary" v-on:click="edit()">Edit</base-button>

            <p class="subtitle" style="margin-top: 50px">Your Generated WCO</p>
            <!--EVERYTIME BUTTON CLICKED ONLY GENERATE PDF & DISPLAY PDF-->
            <base-button type="primary" v-on:click="createPDF()">View</base-button>
          </card>
        </div>
        <div class="col-lg-4 d-flex">
          <card class="card-eprf" style="height: 600px">
            <p class="subtitle" style="margin-top: 50px">
              Please upload any supporting documents
            </p>
            <p class="new-title" style="margin-top: 5px">
              Choose File from Your Desktop
            </p>

            <div class="fileinput">
              <label style="color: white" for="file-upload" type="primary" class="btn">
                Choose File
              </label>
              <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="file-upload" ref="file" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" @change="onFileChange" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 150px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allfilename" :key="index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile(file.fileid)">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>

            <!-- <p class="subtitle" style="margin-top: 50px">Your Generated WCO</p> -->
            <!--EVERYTIME BUTTON CLICKED ONLY GENERATE PDF & DISPLAY PDF-->
            <!-- <base-button type="primary" v-on:click="createPDF()">View</base-button> -->
          </card>
        </div>
        <div class="col-lg"></div>
      </div>

      <div v-if="submit == true" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button wide type="primary" @click="redirect()">
            Done
          </base-button>
        </div>
      </div>

      <div v-if="submit == false" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp;
          <base-button type="primary" v-on:click="submitJobRequest()">Submit</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <p style="color: #EC1B23">{{ errmsg }}</p>
        </div>
      </div>
      <div v-if="submit == false" class="row">
        <div class="col-lg"></div>
        <div v-if="warning == true" class="col-lg-3 text-right">
          <p style="color: #ff0000; font-size: 12px">
            {{ otherswarning }}
          </p>
        </div>
      </div>
      <div v-if="submit == false" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <!-- -->
          <base-button class="btn-link" style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()">
            Save Draft
          </base-button>
        </div>
      </div>
    </div>
    <!-- view / edit -->
    <div v-if="submitted">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">
                {{ locationsubmitted }}
              </p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">
                {{ picsubmitted }}
              </p>

              <p class="new-title">PIC Phone No.</p>
              <p class="subtitle">
                {{ phoneno }}
              </p>

              <p class="new-title">PIC Fax No.</p>
              <p class="subtitle">
                {{ faxno }}
              </p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">
                {{ email }}
              </p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>
            </div>

            <div id="tableku" v-if="load == false" style="height: 500px; overflow: auto; overflow-x: hidden">
              <div class="row">
                <div class="col-lg">
                  <el-table :data="tableDatas" :row-style="tableRowClassName" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p style="color: #707070">
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="200" align="center" prop="wastetype" label="WASTE TYPE">
                      <div slot-scope="{ row }">
                        <div align="left">
                          <p style="color: #707070">
                            Waste Type: {{ row.wastetypename }}
                          </p>
                          <p class="swcode-text" v-if="row.swcode !== '' &&
      row.wastetypename != 'Tyre' &&
      row.wastetypename != 'Garbage' &&
      row.wastetypename != 'Scrap'
      " style="color: #707070">
                            SW Code: {{ row.swcodename }}
                          </p>
                          <p v-if="row.swcode !== '' && row.wastetypename == 'Tyre'
      " style="color: #707070">
                            Tyre Type: {{ row.swcodename }}
                          </p>
                          <p v-if="row.wastetypename != 'Tyre'" style="color: #707070">
                            Packaging: {{ row.packagingname }}
                          </p>
                          <p style="color: #707070">
                            Waste Origin: {{ row.wasteorigin }}
                          </p>
                        </div>
                        <!-- <div class="row"> -->
                        <div class="col-lg-12" v-for="(item, index) in row.images" :key="index">
                          <div class="row" style="border: 1px solid #e6e6e6">
                            <div class="col-lg" style="padding: 5px">
                              <img :src="item.url" width="70" height="40" @click="openimage(item.url)" />
                            </div>
                            <div class="col-lg">
                              <p style="
                                  color: #A5A5A5;
                                  white-space: nowrap;
                                  width: 70px;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  font-size: 10px;
                                  line-height: 1em;
                                ">
                                {{ item.meta.filename }}
                              </p>
                              <p style="
                                  color: grey;
                                  line-height: 0.5;
                                  font-size: 10px;
                                ">
                                {{ item.meta.filesize }}
                              </p>
                            </div>
                            <div class="col-lg-3" style="border: 1px solid #e6e6e6">
                              <base-button class="btn-icon btn-link">
                                <a :href="item.url"><img src="@/assets/img/eprf-download-grey.png"
                                    width="20" /></a></base-button>
                            </div>
                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column v-if="!visibleWasteComp" :min-width="150" align="center" prop="wasteComponents"
                      label="WASTE COMPONENT">
                      <template slot-scope="{ row }">
                        <div v-for="(component, index) in row.wasteComponents" :key="index">
                          {{ index + 1 }}.
                          {{ component.component_name == "" ? "N/A" : component.component_name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :min-width="150" align="center" prop="estqty" label="EST. QTY.">
                      <div slot-scope="{ row }">
                        <p style="color: #707070">
                          {{ row.estqty }} {{ row.estqtyunit }}
                        </p>
                        <p v-if="!visibleWasteComp" style="color: #707070">
                          {{ row.estqtyy }} {{ row.estqtyyunit }}
                        </p>
                        <!-- only for != tyre -->
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="120" align="center" prop="remarks" label="REMARKS">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- hide dulu lepas uat sambung -->
              <!-- <div class="row" style="display: flex; padding-left: 20px;">
                <p style="color: #358CCB; font-size: 18px; font-weight: 600">
                  JOB SUPPORTING DOCUMENTS
                </p>
              </div> -->
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4"></div>
        <div class="col-lg-3 text-left">
          <base-button @click="modals.supportdoc = true" type="primary">View Documents</base-button>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <!-- <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp; -->
          <base-button v-if="jobno && !jobno.toLowerCase().includes('d')" type="primary" v-on:click="createPDF()">Generate WCO</base-button>
          <base-button v-if="jobno && jobno.toLowerCase().includes('d')" type="primary" v-on:click="createTyrePDF()">Generate WCO</base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      errmsg: "",
      otheropen: false,
      quoopen: false,
      imgmsg: "",
      modal: modal,
      docs: "",
      picsubmitted: "",
      imageurl: [],
      phoneno: "",
      wastecomp: "",
      wastetype: "",
      // buttonadd: false,
      //data from submitted data
      locationsubmitted: "",
      wastetypesubmit: "",
      swcodesubmit: "",
      packagingsubmit: "",
      wasteoriginsubmit: "",
      wastecomponentsubmit: [],
      estqtysubmit: "",
      measurementsubmit: "",
      remarkssubmit: "",

      otherswarning: "Please click add new waste type before you submit",
      warning: false,
      showOverlay: false,
      uploadload: false,
      selectedFileName: "",
      allfilename: [],
      allquodocname: [],

      wcodone: false,
      jobreferenceno: "",
      picphoneno: "",
      picemail: "",

      pdftable: [{ no: 0, waste: "", est: "", pack: "" }],

      picdetail: [
        {
          phoneno: "",
          email: "",
          faxno: "",
        },
      ],

      email: "",
      faxno: "",

      wastearray: [],

      referenceno: "",
      wastejobid: 0,

      load: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      specify: "",
      specifywastetype: "",

      deliveryterm: "",
      paymentterm: "",

      jobno: "",
      estimatequatity: "",

      wasteorigin: "",
      remarks: "",

      selects: {
        location: "",
        locations: [
          // { value: 1, label: "Workshop Asia Port, CT1" },
          // { value: 2, label: "Workshop Asia Port, CT1" },
          // { value: 3, label: "Others (Please specify)" },
        ],

        pic: "",
        pics: [
          // { value: 1, label: "Amirah binti Azman" },
          // { value: 2, label: "Yahya Abd Rahman" },
          // { value: 3, label: "Haziq Haikal bin Ayub" },
        ],

        wastetype: "",
        wastetypes: [
          // { value: 1, label: "Scheduled Waste" },
          // { value: 2, label: "Garbage" },
          // { value: 3, label: "Sewage" },
          // { value: 4, label: "Scrap" },
          // { value: 5, label: "Others" },
        ],

        swcode: "",
        swcodes: [
          // { value: 1, label: "SW101" },
          // { value: 2, label: "SW102" },
          // { value: 3, label: "SW103" },
          // { value: 4, label: "SW104" },
          // { value: 5, label: "SW105" },
        ],

        packaging: "",
        packagings: [
          { value: 1, label: "Drum" },
          { value: 2, label: "Carboy" },
          { value: 3, label: "Box" },
          { value: 4, label: "Jumbo Bag" },
          { value: 5, label: "IBC" },
          { value: 6, label: "Unit" },
        ],

        measurement: 1,
        measurements: [
          { value: "MT", label: "MT" },
          { value: "M³", label: "M³" },
        ],

        collection: 1,
        collections: [],
      },

      wastedetail: [
        {
          prop: "wastetype",
          label: "Waste Type",
        },
        {
          prop: "wastecomponent",
          label: "Waste Component",
        },
        {
          prop: "estqty",
          label: "EST. QTY.",
        },
        {
          prop: "remarks",
          label: "Remarks",
        },
      ],

      tableDatas: [
        {
          index: 0,
          id: "1",
          buttonadd: true,
          wastetype: "",
          wastetypename: "",
          nickname: "",
          swcode: "",
          swcodes: [],
          packaging: "",
          wasteorigin: "",
          wasteComponents: [
            {
              component_name: "",
            },
          ],
          estqty: "",
          estqtyy: "",
          packagingname: "",
          measurement: "",
          remarks: "",
          images: [],
          previewImage: [],
          // "https://www.tutorialspoint.com/assets/questions/media/426142-1668760872.png",
        },
      ],

      packagingname: "",

      modals: {
        submit: false,
        drafted: false,
        warningsubmit: false,
        supportdoc: false,
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
      },
      submit: false,

      newwastetypeid: null,

      collectiondate: "",

      submitted: false,
      documentID: [],

      //pdf
      companyname: "",
      deliveryno: "NPX1234",
      date: "",
      currentpage: "",
      totalpage: "",
      companyaddress: "",
      companyphoneno: "",
      companyemail: "xxx@gmail.com",
      attention: "",
      subject: "Quotation for Scheduled Waste for PRF",

      deliverypdf: "7",
      paymentpdf: "30",
      validitypdf: "30",
      remarkspdf:
        "Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF",

      pic1pdf: "",
      pic1nopdf: "",
      pic2pdf: "",
      pic2nopdf: "",

      packagingchose: "",
      packagingLabel: "",

      gambarwco: [],

      wastecomponent: [],
    };
  },
  created() {
    // console.log(this.$on('lalalala', (data) => {
    //   console.log(data)
    // }))
    this.$root.$on("lalalala", this.handleevent);
    // this.collectiondate = sessionStorage.getItem("collectiondate");

    this.jobno = this.$route.params.jobnum;

    this.getPIC();
    if (this.$route.params.action == "edit") {
      this.getLocation();
      this.getWasteType();
      this.submitted = false;
      this.getSubmittedData();
    }
    else if (this.$route.params.action == "add") {
      // add
      this.submitted = false;
      this.getLocation();

      this.getWasteType();
      // this.getSWCode();
      this.getPackaging();

      this.collectiondate = sessionStorage.getItem("collectiondate");
      console.log('date', this.collectiondate);
    }
    else if (this.$route.params.action == "view") {
      // edit / view
      this.submitted = true;
      // this.getData();
      this.getSubmittedData();
    }

    // this.getPDF();
  },
  mounted() {
    if (this.submitted == true) {
      this.getPDF();
    }
  },
  computed: {
    visibleWasteComp() {
      return this.tableDatas.some(
        (row) =>
          row.wastetypename === "Tyre" ||
          row.wastetypename === "tyre" ||
          row.wastetypename === "Scrap" ||
          row.wastetypename === "scrap"
      );
    },
  },
  watch: {
    "selects.pic"() {
      for (var i = 0; i < this.selects.pics.length; i++) {
        if (this.selects.pic == this.selects.pics[i].value) {
          this.phoneno =
            this.selects.pics[i].phoneno == "" ||
              this.selects.pics[i].phoneno == null
              ? "N/A"
              : this.selects.pics[i].phoneno;
          this.faxno =
            this.selects.pics[i].faxno == "" ||
              this.selects.pics[i].faxno == null
              ? "N/A"
              : this.selects.pics[i].faxno;
          this.email = this.selects.pics[i].email;
        }
      }
    },

    "row.specifywastetype"() {
      this.warning = true;
    },
    "selects.location"() {
      console.log("read chanegs");
      this.selects.collection = "";
      this.locations();
    },
    wastetype() { },
    phoneno() { },
  },
  openother() {
    console.log("okay ke?");

    this.otheropen = !this.otheropen;
  },
  openquo() {
    console.log("okay ke?");

    this.quoopen = !this.quoopen;
  },
  methods: {
    handleevent(data) {
      console.log(data);
      this.collectiondate = data;
    },
    openother() {
      console.log("okay ke?");

      this.otheropen = !this.otheropen;
    },
    openquo() {
      console.log("okay ke?");

      this.quoopen = !this.quoopen;
    },
    deletecomponent(tableindex, componentindex) {
      this.tableDatas[tableindex].wasteComponents.splice(componentindex, 1);
    },
    deleteimage(tableindex, imageindex) {
      // console.log(tableindex);
      // console.log(imageindex);
      this.tableDatas[tableindex].images.splice(imageindex, 1);
    },
    onImagesChange(e, index, flag) {
      if (flag != "") {
        this.load = true;

        if (flag == "scrap") {
          const input = e.target;
          const formData = new FormData();
          for (let i = 0; i < input.files.length; i++) {
            formData.append("images", input.files[i]);
          }

          // to verify form data
          for (var pair of formData.entries()) {
            console.log(pair);
          }

          this.$http
            .post(
              ":10001/api/v1/incoming/scrap/" + this.jobno + "/image",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                // let imageurl = [];
                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    url: response[i].url,
                    waste_detail_image_id: response[i].waste_detail_image_id,
                  };
                  this.imageurl.push(obj);
                }
                this.tableDatas[index].images = this.imageurl;
                this.load = false;
              }
            });
        }

        if (flag == "tyre") {
          const input = e.target;
          const formData = new FormData();
          for (let i = 0; i < input.files.length; i++) {
            formData.append("images", input.files[i]);
          }

          // to verify form data
          for (var pair of formData.entries()) {
            console.log(pair);
          }

          this.$http
            .post(
              ":10001/api/v1/incoming/tyre/" + this.jobno + "/image",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    url: response[i].url,
                    waste_detail_image_id: response[i].waste_detail_image_id,
                  };
                  this.tableDatas[index].images.push(obj);
                }
                // this.tableDatas[index].images = this.imageurl;
                this.load = false;
              }
            });
        }

        if (flag == "schedule_waste") {
          const input = e.target;
          const formData = new FormData();
          for (let i = 0; i < input.files.length; i++) {
            formData.append("images", input.files[i]);
          }

          // to verify form data
          for (var pair of formData.entries()) {
            console.log(pair);
          }

          this.$http
            .post(
              ":10001/api/v1/incoming/sw/" + this.jobno + "/image",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    url: response[i].url,
                    waste_detail_image_id: response[i].waste_detail_image_id,
                  };
                  this.tableDatas[index].images.push(obj);
                }
                // this.tableDatas[index].images = this.imageurl;
                this.load = false;
              }
            });
        }

        if (flag == "garbage") {
          const input = e.target;
          const formData = new FormData();
          for (let i = 0; i < input.files.length; i++) {
            formData.append("images", input.files[i]);
          }

          // to verify form data
          for (var pair of formData.entries()) {
            console.log(pair);
          }

          this.$http
            .post(
              ":10001/api/v1/incoming/garbage/" + this.jobno + "/image",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    url: response[i].url,
                    waste_detail_image_id: response[i].waste_detail_image_id,
                  };
                  this.tableDatas[index].images.push(obj);
                }
                // this.tableDatas[index].images = this.imageurl;
                this.load = false;
              }
            });
        }

        if (flag == "others") {
          const input = e.target;
          const formData = new FormData();
          for (let i = 0; i < input.files.length; i++) {
            formData.append("images", input.files[i]);
          }

          // to verify form data
          for (var pair of formData.entries()) {
            console.log(pair);
          }

          this.$http
            .post(
              ":10001/api/v1/incoming/others/" + this.jobno + "/image",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    url: response[i].url,
                    waste_detail_image_id: response[i].waste_detail_image_id,
                  };
                  this.tableDatas[index].images.push(obj);
                }
                // this.tableDatas[index].images = this.imageurl;
                this.load = false;
              }
            });
        }
      } else {
        this.imgmsg =
          "Please select waste type first before proceed upload image";
      }
    },
    redirect() {
      this.$router.push("/Land/Request");
    },
    locations() {
      console.log("collections");
      this.selects.collections = [];
      this.$http
        .get(
          ":10001/api/v1/reference/service-location/" + this.selects.location
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            if (response.length != 0) {
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  label: response[i].Name,
                  value: response[i].ServiceLocationCollectionId,
                };
                this.selects.collections.push(obj);
              }

              // this.selects.collection = this.selects.collections[0].value;
            }
          }
        });
    },
    getPDF() {
      console.log("hello");

      this.pdftable = [];
      // pdftable: [{ no: 0, waste: "", est: "", pack: ""}],

      // this.jobno = "NGL240131358";

      this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/wco")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("hui", response);

            this.attention = response.customer_name;

            this.companyname = response.company_name;
            this.companyaddress = response.company_address;
            this.locationname = response.service_location;
            // this.companyaddress = "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloremque praesentium et voluptas molestias eveniet magni recusandae asperiores, laboriosam blanditiis cupiditate, amet, similique inventore laudantium illo! Voluptatem rem voluptates nostrum asperiores?";

            this.companyphoneno = response.customer_phone_number;
            this.companyemail = response.customer_email;

            // this.date = moment(sessionStorage.getItem("collectiondate")).format("DD-MM-YYYY");
            this.date = moment().format("DD.MM.YYYY");
            this.wastecomponent = [];

            this.gambarwco = [];

            for (var i = 0; i < response.waste_detail_image.length; i++) {
              let imageUrl = response.waste_detail_image[i].url;
              console.log('gmbo', imageUrl);
              if (imageUrl.toLowerCase().endsWith(".png") || imageUrl.toLowerCase().endsWith(".jpeg") || imageUrl.toLowerCase().endsWith(".jpg")) {
                this.gambarwco.push(imageUrl);
              } else
                if (imageUrl != null) {
                  this.gambarwco.push("@/assets/img/No_Available_Image.png");
                } else {
                  // this.gambarwco.push('https://afes-eprf.s3.ap-southeast-1.amazonaws.com/default/No_Image_Available.jpg');
                  this.gambarwco.push("@/assets/img/Corrupted_Image.png");
                }
            }

            console.log("ini gmbr", this.gambarwco.length);

            for (var i = 0; i < response.waste_detail.length; i++) {
              let combinedName = "";
              for (
                var j = 0;
                j < response.waste_detail[i].waste_component.length;
                j++
              ) {
                if (j > 0) {
                  combinedName += ", "; // Add a separator between component names
                }
                combinedName += String(
                  response.waste_detail[i].waste_component[j].component_name
                );
              }
              let obj = {
                name: combinedName,
              };
              this.wastecomponent.push(obj);
            }

            console.log(this.wastecomponent[0].name);

            if (
              response.waste_detail[0].waste_type_name ==
              "Scheduled Waste and Washwater" ||
              response.waste_detail[0].waste_type_name == "Schedule Waste"
            )
              for (var i = 0; i < response.waste_detail.length; i++) {
                // for (var i = 0; i < response.waste_detail.length; i++) {
                //   let images = {

                //   }
                // }

                let obj = {
                  no: i + 1,
                  waste:
                    // response.waste_detail[i].waste_type_name +
                    // "\n" +
                    // "Waste Sub Type: " +
                    response.waste_detail[i].waste_sub_type_name,
                  // +
                  // "\n" +
                  // "Origin: " +
                  // response.waste_detail[i].waste_source +
                  // "\n" +
                  // "Waste Component: " +
                  // this.wastecomponent[i].name +
                  // "\n" +
                  // "Remark: " +
                  // response.waste_detail[i].remarks, // tambah sub type
                  est:
                    response.waste_detail[i].estimated_quantity.toString() +
                    " " +
                    response.waste_detail[i].estimated_quantity_unit,
                  // + "\n" + response.waste_detail[i].packaging_quantity.toString() +
                  // " " +
                  // response.waste_detail[i].packaging_name, // unit tak keluar sebab takde unit masuk lepas submit
                  pack:
                    response.waste_detail[i].packaging_quantity.toString() +
                    " " +
                    response.waste_detail[i].packaging_name,
                };
                this.pdftable.push(obj);
              }

            if (
              response.waste_detail[0].waste_type_name == "Others"
            )
              for (var i = 0; i < response.waste_detail.length; i++) {
                // for (var i = 0; i < response.waste_detail.length; i++) {
                //   let images = {

                //   }
                // }

                let obj = {
                  no: i + 1,
                  waste:
                    response.waste_detail[i].waste_type_name,
                  //  +
                  // "\n" +
                  // "Waste Sub Type: " +
                  // response.waste_detail[i].waste_sub_type_name,
                  // +
                  // "\n" +
                  // "Origin: " +
                  // response.waste_detail[i].waste_source +
                  // "\n" +
                  // "Waste Component: " +
                  // this.wastecomponent[i].name +
                  // "\n" +
                  // "Remark: " +
                  // response.waste_detail[i].remarks, // tambah sub type
                  est:
                    response.waste_detail[i].estimated_quantity.toString() +
                    " " +
                    response.waste_detail[i].estimated_quantity_unit,
                  // + "\n" + response.waste_detail[i].packaging_quantity.toString() +
                  // " " +
                  // response.waste_detail[i].packaging_name, // unit tak keluar sebab takde unit masuk lepas submit
                  pack:
                    response.waste_detail[i].packaging_quantity.toString() +
                    " " +
                    response.waste_detail[i].packaging_name,
                };
                this.pdftable.push(obj);
              }

            if (
              response.waste_detail[0].waste_type_name == "Garbage" ||
              response.waste_detail[0].waste_type_name == "Scrap"
            )
              for (var i = 0; i < response.waste_detail.length; i++) {
                let obj = {
                  no: i + 1,
                  waste:
                    response.waste_detail[i].waste_type_name +
                    ", " +
                    response.waste_detail[i].waste_sub_type_name,
                  // +
                  // "\n" +
                  // "Origin: " +
                  // response.waste_detail[i].waste_source +
                  // "\n" +
                  // "Waste Component: " +
                  // this.wastecomponent[i].name +
                  // "\n" +
                  // "Remark: " +
                  // response.waste_detail[i].remarks, // tambah sub type
                  est:
                    response.waste_detail[i].estimated_quantity.toString() +
                    " " +
                    response.waste_detail[i].estimated_quantity_unit,
                  // "\n" +
                  // response.waste_detail[i].packaging_quantity.toString() +
                  // " " +
                  // response.waste_detail[i].packaging_name, // unit tak keluar sebab takde unit masuk lepas submit
                  pack:
                    response.waste_detail[i].packaging_quantity.toString() +
                    " " +
                    response.waste_detail[i].packaging_name,
                };
                this.pdftable.push(obj);
              }

            if (response.waste_detail[0].waste_type_name == "Tyre")
              for (var i = 0; i < response.waste_detail.length; i++) {
                let obj = {
                  no: i + 1,
                  waste:
                    response.waste_detail[i].waste_type_name +
                    ", " +
                    response.waste_detail[i].waste_sub_type_name,
                  // +
                  // "\n" +
                  // "Origin: " +
                  // response.waste_detail[i].waste_source +
                  // "\n" +
                  // "Tyre Type: " +
                  // response.waste_detail[i].waste_sub_type_name +
                  // "\n" +
                  // "Remark: " +
                  // response.waste_detail[i].remarks, // tambah sub type
                  est:
                    response.waste_detail[i].estimated_quantity.toString() +
                    " Unit",
                  pack:
                    response.waste_detail[i].packaging_quantity.toString() +
                    " " +
                    response.waste_detail[i].packaging_name,
                };
                this.pdftable.push(obj);
              }
          }
        });
    },
    createPDF() {
      // const doc = new jsPDF();

      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const image1 = new Image();
      const image2 = new Image();
      const image3 = new Image();
      const image4 = new Image();

      if (this.gambarwco.length == 1) {
        const logoimageurl1 = this.gambarwco[0];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };
        // var logoimageurl1 = this.gambarwco[0];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 2) {

        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];

        // // image1.src = logoimageurl1;

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 3) {
        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];
        const logoimageurl3 = this.gambarwco[2];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        if (
          logoimageurl3 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl3 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image3.src = logoimageurl3;
        } else if (logoimageurl3 === '@/assets/img/No_Available_Image.png') {
          image3.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl3 === '@/assets/img/Corrupted_Image.png') {
          image3.src = require('@/assets/img/Corrupted_Image.png');
        }

        image3.onload = () => {
          this.options = Object.assign({}, this.options, {
            image3: {
              image3,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];
        // var logoimageurl3 = this.gambarwco[2];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // // image1.src = logoimageurl1;
        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };

        // if (logoimageurl3 != '@/assets/img/No_Available_Image.png' && logoimageurl3 != '@/assets/img/Corrupted_Image.png') {
        //   image3.src = logoimageurl3;
        // } else {
        //   image3.src = require(logoimageurl3);
        // }

        // // image3.src = logoimageurl3;
        // image3.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image3: {
        //       image3,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 4) {
        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];
        const logoimageurl3 = this.gambarwco[2];
        const logoimageurl4 = this.gambarwco[3];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        if (
          logoimageurl3 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl3 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image3.src = logoimageurl3;
        } else if (logoimageurl3 === '@/assets/img/No_Available_Image.png') {
          image3.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl3 === '@/assets/img/Corrupted_Image.png') {
          image3.src = require('@/assets/img/Corrupted_Image.png');
        }

        image3.onload = () => {
          this.options = Object.assign({}, this.options, {
            image3: {
              image3,
            },
          });
        };

        if (
          logoimageurl4 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl4 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image4.src = logoimageurl4;
        } else if (logoimageurl4 === '@/assets/img/No_Available_Image.png') {
          image4.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl4 === '@/assets/img/Corrupted_Image.png') {
          image4.src = require('@/assets/img/Corrupted_Image.png');
        }

        image4.onload = () => {
          this.options = Object.assign({}, this.options, {
            image4: {
              image4,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];
        // var logoimageurl3 = this.gambarwco[2];
        // var logoimageurl4 = this.gambarwco[3];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // // image1.src = logoimageurl1;
        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };

        // if (logoimageurl3 != '@/assets/img/No_Available_Image.png' && logoimageurl3 != '@/assets/img/Corrupted_Image.png') {
        //   image3.src = logoimageurl3;
        // } else {
        //   image3.src = require(logoimageurl3);
        // }

        // // image3.src = logoimageurl3;
        // image3.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image3: {
        //       image3,
        //     },
        //   });
        // };

        // if (logoimageurl4 != '@/assets/img/No_Available_Image.png' && logoimageurl4 != '@/assets/img/Corrupted_Image.png') {
        //   image4.src = logoimageurl4;
        // } else {
        //   image4.src = require(logoimageurl4);
        // }

        // // image4.src = logoimageurl4;
        // image4.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image4: {
        //       image4,
        //     },
        //   });
        // };
      }
      // Example data to include in the PDF
      const data = this.pdftable;

      const customRow = "\t\t\t\t\t\t\tWASTE PARTICULARS";

      // Define the columns for the table
      const columns = [
        "No.",
        "\t\t\t\tWaste Code or Waste Description",
        "Packaging",
        "Quantity (MT)",
      ];
      // Define the rows for the table
      const rows = data.map((obj) => [obj.no, obj.waste, obj.pack, obj.est]);

      // Add logo image on top right
      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      ); // Adjust position and dimensions as needed

      // Add title "Quotation" on top left
      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("WASTE COLLECTION ORDER", 15, 40);
      doc.setFontSize(11);
      doc.setFontStyle("normal");
      // doc.text("DHES SST ID No :", 130, 40);
      doc.setFontStyle("bold");

      doc.text("CUSTOMER DETAIL", 20, 55);

      doc.text(this.attention, 20, 60);
      doc.setFontStyle("normal");
      doc.text(this.companyname, 20, 65);
      var companyAddress = this.companyaddress;
      var maxCharactersPerLine = 40;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 70 + i * 5;
        doc.text(addressLines[i], 20, yPos);
      }

      var boxheight = addressLines.length * 14.5;
      doc.setDrawColor(0, 0, 0);

      doc.rect(15, 50, 80, boxheight);

      var squareX = 110;
      var squareY = 50;
      var squareWidth = 85;
      var squareHeight = 20; // Adjusted height

      doc.setDrawColor(0, 0, 0);
      // Draw a square
      doc.rect(squareX, squareY, squareWidth, squareHeight);

      // Set up text
      var textX = squareX + 5; // Adjust this value as needed for text position
      var textY = squareY + 7; // Adjust this value as needed for text position
      var lineHeight = 7; // Adjust this value as needed for line spacing

      // Add text inside the square
      doc.text("Collection Order No.", textX, textY);
      // doc.text("Order No.", textX, textY + lineHeight);
      doc.text("Date", textX, textY + lineHeight);

      // Add colons
      doc.text(" : ", textX + 35, textY);
      doc.text(" : ", textX + 35, textY + lineHeight);

      // Add dynamic data
      doc.text(this.jobno, textX + 38, textY);
      doc.text(this.date, textX + 38, textY + lineHeight);
      doc.setDrawColor(0, 0, 0);

      doc.rect(14.3, 89, 181.5, 10);
      doc.setFontStyle("bold");

      doc.text("WASTE PARTICULAR", 80, 95);

      //   // Draw the custom row above the table header
      //   const customRowHeight = 10; // Define the height of the custom row
      //   const customRowPadding = 5; // Define padding inside the custom row

      //   // doc.setFontSize(12); // Set font size for the custom row

      //   doc.setFontStyle('bold');

      //   // Get the width of the text
      //   const textWidth = doc.getTextWidth(customRow);
      //   const textX = data.settings.margin.left + customRowPadding;
      //   const textY = 55 + boxheight + customRowPadding + customRowHeight / 2;

      //   // Draw the text
      //   doc.text(customRow, textX, textY, { baseline: 'middle' });

      //   // Draw the border
      //   const borderX = data.settings.margin.left;
      //   const borderY = 60 + boxheight;
      //   const borderWidth = 181.7;
      //   // const borderWidth = textWidth + customRowPadding * 2;

      //   const borderHeight = customRowHeight;

      //   // Set the same line width and color as the table border
      //   doc.setLineWidth(0.200025); // Adjust as needed to match the table border width
      //   doc.setDrawColor(200, 200, 200); // Adjust as needed to match the table border color

      //   doc.rect(borderX, borderY, borderWidth, borderHeight, 'S');

      // Add the table to the PDF using autoTable plugin
      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 21,
          },
          3: {
            halign: "center",
            cellWidth: 27,
          },
        },
        theme: "plain",
        body: rows,
        startY: 69.9 + boxheight, // Adjust the starting position of the table to make space for the logo and title
        // didDrawPage: function (data) {
        //   // Draw the custom row above the table header
        //   const customRowHeight = 10; // Define the height of the custom row
        //   const customRowPadding = 5; // Define padding inside the custom row

        //   // doc.setFontSize(12); // Set font size for the custom row

        //   doc.setFontStyle('bold');

        //   // Get the width of the text
        //   const textWidth = doc.getTextWidth(customRow);
        //   const textX = data.settings.margin.left + customRowPadding;
        //   const textY = 55 + boxheight + customRowPadding + customRowHeight / 2;

        //   // Draw the text
        //   doc.text(customRow, textX, textY, { baseline: 'middle' });

        //   // Draw the border
        //   const borderX = data.settings.margin.left;
        //   const borderY = 60 + boxheight;
        //   const borderWidth = 181.7;
        //   // const borderWidth = textWidth + customRowPadding * 2;

        //   const borderHeight = customRowHeight;

        //   // Set the same line width and color as the table border
        //   doc.setLineWidth(0.200025); // Adjust as needed to match the table border width
        //   doc.setDrawColor(200, 200, 200); // Adjust as needed to match the table border color

        //   doc.rect(borderX, borderY, borderWidth, borderHeight, 'S');
        // },
        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);

          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },
      });

      doc.setFontStyle("bold");

      doc.text("Waste Images", 15, table.autoTable.previous.finalY + 10);

      if (this.gambarwco.length == 1) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }
      if (this.gambarwco.length == 2) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      if (this.gambarwco.length == 3) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image3,
          "PNG",
          105,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      if (this.gambarwco.length == 4) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image3,
          "PNG",
          105,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image4,
          "PNG",
          150,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      let aftertable = table.autoTable.previous.finalY + 10;

      let afterphoto = 50;

      if (aftertable > doc.internal.pageSize.getHeight() / 2) {
        doc.addPage();
        aftertable = 10;
        afterphoto = 0;
      }

      doc.text(this.companyname, 15, aftertable + afterphoto + 5);
      doc.setFontStyle("normal");

      doc.text(this.locationname, 15, aftertable + afterphoto + 10);
      doc.text(
        "I/We hereby accept the above services in a good order and condition:-",
        15,
        aftertable + afterphoto + 20
      );
      doc.text("Name", 15, aftertable + afterphoto + 30);
      doc.text(
        ": ___________________________________",
        55,
        aftertable + afterphoto + 30
      );

      doc.text("Signature", 15, aftertable + afterphoto + 40);
      doc.text(
        ": ___________________________________",
        55,
        aftertable + afterphoto + 40
      );

      doc.text("Company Stamp", 15, aftertable + afterphoto + 50);
      doc.text(": ", 55, aftertable + afterphoto + 50);
      doc.setFontStyle("bold");

      doc.text(
        "Alam Flora Environmental Solutions Sdn. Bhd. (AFES)",
        55,
        aftertable + afterphoto + 55
      );
      // doc.setFontSize(8);
      // doc.setFontStyle("italic");
      doc.setFontStyle("normal");

      doc.text(
        "(previously known as DRB-HICOM Environmental Services Sdn Bhd)",
        45,
        aftertable + afterphoto + 60
      );
      // doc.setFontSize(11);
      doc.text(
        "Level 2, EON Head Office Complex, 2, Persiaran Kerjaya U1",
        55,
        aftertable + afterphoto + 70
      );
      doc.text(
        "40150 Shah Alam, Selangor Darul Ehsan, MALAYSIA",
        60,
        aftertable + afterphoto + 75
      );
      doc.text(
        "Tel: (603) 7803 0518 Fax: (603) 7809 0137 Web: www.afes.com.my",
        45,
        aftertable + afterphoto + 80
      );

      doc.save("Waste Collection Order.pdf");
    },
    createTyrePDF() {
      // const doc = new jsPDF();

      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const image1 = new Image();
      const image2 = new Image();
      const image3 = new Image();
      const image4 = new Image();

      if (this.gambarwco.length == 1) {
        const logoimageurl1 = this.gambarwco[0];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };
        // var logoimageurl1 = this.gambarwco[0];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 2) {

        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];

        // // image1.src = logoimageurl1;

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 3) {
        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];
        const logoimageurl3 = this.gambarwco[2];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        if (
          logoimageurl3 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl3 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image3.src = logoimageurl3;
        } else if (logoimageurl3 === '@/assets/img/No_Available_Image.png') {
          image3.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl3 === '@/assets/img/Corrupted_Image.png') {
          image3.src = require('@/assets/img/Corrupted_Image.png');
        }

        image3.onload = () => {
          this.options = Object.assign({}, this.options, {
            image3: {
              image3,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];
        // var logoimageurl3 = this.gambarwco[2];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // // image1.src = logoimageurl1;
        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };

        // if (logoimageurl3 != '@/assets/img/No_Available_Image.png' && logoimageurl3 != '@/assets/img/Corrupted_Image.png') {
        //   image3.src = logoimageurl3;
        // } else {
        //   image3.src = require(logoimageurl3);
        // }

        // // image3.src = logoimageurl3;
        // image3.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image3: {
        //       image3,
        //     },
        //   });
        // };
      }

      if (this.gambarwco.length == 4) {
        const logoimageurl1 = this.gambarwco[0];
        const logoimageurl2 = this.gambarwco[1];
        const logoimageurl3 = this.gambarwco[2];
        const logoimageurl4 = this.gambarwco[3];

        if (
          logoimageurl1 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl1 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image1.src = logoimageurl1;
        } else if (logoimageurl1 === '@/assets/img/No_Available_Image.png') {
          image1.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl1 === '@/assets/img/Corrupted_Image.png') {
          image1.src = require('@/assets/img/Corrupted_Image.png');
        }

        image1.onload = () => {
          this.options = Object.assign({}, this.options, {
            image1: {
              image1,
            },
          });
        };

        if (
          logoimageurl2 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl2 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image2.src = logoimageurl2;
        } else if (logoimageurl2 === '@/assets/img/No_Available_Image.png') {
          image2.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl2 === '@/assets/img/Corrupted_Image.png') {
          image2.src = require('@/assets/img/Corrupted_Image.png');
        }

        image2.onload = () => {
          this.options = Object.assign({}, this.options, {
            image2: {
              image2,
            },
          });
        };

        if (
          logoimageurl3 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl3 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image3.src = logoimageurl3;
        } else if (logoimageurl3 === '@/assets/img/No_Available_Image.png') {
          image3.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl3 === '@/assets/img/Corrupted_Image.png') {
          image3.src = require('@/assets/img/Corrupted_Image.png');
        }

        image3.onload = () => {
          this.options = Object.assign({}, this.options, {
            image3: {
              image3,
            },
          });
        };

        if (
          logoimageurl4 !== '@/assets/img/No_Available_Image.png' &&
          logoimageurl4 !== '@/assets/img/Corrupted_Image.png'
        ) {
          image4.src = logoimageurl4;
        } else if (logoimageurl4 === '@/assets/img/No_Available_Image.png') {
          image4.src = require('@/assets/img/No_Available_Image.png');
        } else if (logoimageurl4 === '@/assets/img/Corrupted_Image.png') {
          image4.src = require('@/assets/img/Corrupted_Image.png');
        }

        image4.onload = () => {
          this.options = Object.assign({}, this.options, {
            image4: {
              image4,
            },
          });
        };

        // var logoimageurl1 = this.gambarwco[0];
        // var logoimageurl2 = this.gambarwco[1];
        // var logoimageurl3 = this.gambarwco[2];
        // var logoimageurl4 = this.gambarwco[3];

        // if (logoimageurl1 != '@/assets/img/No_Available_Image.png' && logoimageurl1 != '@/assets/img/Corrupted_Image.png') {
        //   image1.src = logoimageurl1;
        // } else {
        //   image1.src = require(logoimageurl1);
        // }

        // // image1.src = logoimageurl1;
        // image1.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image1: {
        //       image1,
        //     },
        //   });
        // };

        // if (logoimageurl2 != '@/assets/img/No_Available_Image.png' && logoimageurl2 != '@/assets/img/Corrupted_Image.png') {
        //   image2.src = logoimageurl2;
        // } else {
        //   image2.src = require(logoimageurl2);
        // }

        // // image2.src = logoimageurl2;
        // image2.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image2: {
        //       image2,
        //     },
        //   });
        // };

        // if (logoimageurl3 != '@/assets/img/No_Available_Image.png' && logoimageurl3 != '@/assets/img/Corrupted_Image.png') {
        //   image3.src = logoimageurl3;
        // } else {
        //   image3.src = require(logoimageurl3);
        // }

        // // image3.src = logoimageurl3;
        // image3.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image3: {
        //       image3,
        //     },
        //   });
        // };

        // if (logoimageurl4 != '@/assets/img/No_Available_Image.png' && logoimageurl4 != '@/assets/img/Corrupted_Image.png') {
        //   image4.src = logoimageurl4;
        // } else {
        //   image4.src = require(logoimageurl4);
        // }

        // // image4.src = logoimageurl4;
        // image4.onload = () => {
        //   this.options = Object.assign({}, this.options, {
        //     image4: {
        //       image4,
        //     },
        //   });
        // };
      }
      // Example data to include in the PDF
      const data = this.pdftable;

      const customRow = "\t\t\t\t\t\t\tWASTE PARTICULARS";

      // Define the columns for the table
      const columns = [
        "No.",
        "\t\t\t\tWaste Code or Waste Description",
        // "Packaging",
        "Quantity (Unit)",
      ];
      // Define the rows for the table
      const rows = data.map((obj) => [obj.no, obj.waste, obj.est]);

      // Add logo image on top right
      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      ); // Adjust position and dimensions as needed

      // Add title "Quotation" on top left
      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("WASTE COLLECTION ORDER", 15, 40);
      doc.setFontSize(11);
      doc.setFontStyle("normal");
      // doc.text("DHES SST ID No :", 130, 40);
      doc.setFontStyle("bold");

      doc.text("CUSTOMER DETAIL", 20, 55);

      doc.text(this.attention, 20, 60);
      doc.setFontStyle("normal");
      doc.text(this.companyname, 20, 65);
      var companyAddress = this.companyaddress;
      var maxCharactersPerLine = 40;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 70 + i * 5;
        doc.text(addressLines[i], 20, yPos);
      }

      var boxheight = addressLines.length * 14.5;
      doc.setDrawColor(0, 0, 0);

      doc.rect(15, 50, 80, boxheight);

      var squareX = 110;
      var squareY = 50;
      var squareWidth = 85;
      var squareHeight = 20; // Adjusted height

      doc.setDrawColor(0, 0, 0);
      // Draw a square
      doc.rect(squareX, squareY, squareWidth, squareHeight);

      // Set up text
      var textX = squareX + 5; // Adjust this value as needed for text position
      var textY = squareY + 7; // Adjust this value as needed for text position
      var lineHeight = 7; // Adjust this value as needed for line spacing

      // Add text inside the square
      doc.text("Collection Order No.", textX, textY);
      // doc.text("Order No.", textX, textY + lineHeight);
      doc.text("Date", textX, textY + lineHeight);

      // Add colons
      doc.text(" : ", textX + 35, textY);
      doc.text(" : ", textX + 35, textY + lineHeight);

      // Add dynamic data
      doc.text(this.jobno, textX + 38, textY);
      doc.text(this.date, textX + 38, textY + lineHeight);
      doc.setDrawColor(0, 0, 0);

      doc.rect(14.3, 89, 181.5, 10);
      doc.setFontStyle("bold");

      doc.text("WASTE PARTICULAR", 80, 95);

      //   // Draw the custom row above the table header
      //   const customRowHeight = 10; // Define the height of the custom row
      //   const customRowPadding = 5; // Define padding inside the custom row

      //   // doc.setFontSize(12); // Set font size for the custom row

      //   doc.setFontStyle('bold');

      //   // Get the width of the text
      //   const textWidth = doc.getTextWidth(customRow);
      //   const textX = data.settings.margin.left + customRowPadding;
      //   const textY = 55 + boxheight + customRowPadding + customRowHeight / 2;

      //   // Draw the text
      //   doc.text(customRow, textX, textY, { baseline: 'middle' });

      //   // Draw the border
      //   const borderX = data.settings.margin.left;
      //   const borderY = 60 + boxheight;
      //   const borderWidth = 181.7;
      //   // const borderWidth = textWidth + customRowPadding * 2;

      //   const borderHeight = customRowHeight;

      //   // Set the same line width and color as the table border
      //   doc.setLineWidth(0.200025); // Adjust as needed to match the table border width
      //   doc.setDrawColor(200, 200, 200); // Adjust as needed to match the table border color

      //   doc.rect(borderX, borderY, borderWidth, borderHeight, 'S');

      // Add the table to the PDF using autoTable plugin
      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 30,
          },
          // 3: {
          //   halign: "center",
          //   cellWidth: 27,
          // },
        },
        theme: "plain",
        body: rows,
        startY: 69.9 + boxheight, // Adjust the starting position of the table to make space for the logo and title
        // didDrawPage: function (data) {
        //   // Draw the custom row above the table header
        //   const customRowHeight = 10; // Define the height of the custom row
        //   const customRowPadding = 5; // Define padding inside the custom row

        //   // doc.setFontSize(12); // Set font size for the custom row

        //   doc.setFontStyle('bold');

        //   // Get the width of the text
        //   const textWidth = doc.getTextWidth(customRow);
        //   const textX = data.settings.margin.left + customRowPadding;
        //   const textY = 55 + boxheight + customRowPadding + customRowHeight / 2;

        //   // Draw the text
        //   doc.text(customRow, textX, textY, { baseline: 'middle' });

        //   // Draw the border
        //   const borderX = data.settings.margin.left;
        //   const borderY = 60 + boxheight;
        //   const borderWidth = 181.7;
        //   // const borderWidth = textWidth + customRowPadding * 2;

        //   const borderHeight = customRowHeight;

        //   // Set the same line width and color as the table border
        //   doc.setLineWidth(0.200025); // Adjust as needed to match the table border width
        //   doc.setDrawColor(200, 200, 200); // Adjust as needed to match the table border color

        //   doc.rect(borderX, borderY, borderWidth, borderHeight, 'S');
        // },
        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);

          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },
      });

      doc.setFontStyle("bold");

      doc.text("Waste Images", 15, table.autoTable.previous.finalY + 10);

      if (this.gambarwco.length == 1) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }
      if (this.gambarwco.length == 2) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      if (this.gambarwco.length == 3) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image3,
          "PNG",
          105,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      if (this.gambarwco.length == 4) {
        doc.addImage(
          image1,
          "PNG",
          15,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image2,
          "PNG",
          60,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image3,
          "PNG",
          105,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );

        doc.addImage(
          image4,
          "PNG",
          150,
          table.autoTable.previous.finalY + 10 + 5,
          40,
          40
        );
      }

      let aftertable = table.autoTable.previous.finalY + 10;

      let afterphoto = 50;

      if (aftertable > doc.internal.pageSize.getHeight() / 2) {
        doc.addPage();
        aftertable = 10;
        afterphoto = 0;
      }

      doc.text(this.companyname, 15, aftertable + afterphoto + 5);
      doc.setFontStyle("normal");

      doc.text(this.locationname, 15, aftertable + afterphoto + 10);
      doc.text(
        "I/We hereby accept the above services in a good order and condition:-",
        15,
        aftertable + afterphoto + 20
      );
      doc.text("Name", 15, aftertable + afterphoto + 30);
      doc.text(
        ": ___________________________________",
        55,
        aftertable + afterphoto + 30
      );

      doc.text("Signature", 15, aftertable + afterphoto + 40);
      doc.text(
        ": ___________________________________",
        55,
        aftertable + afterphoto + 40
      );

      doc.text("Company Stamp", 15, aftertable + afterphoto + 50);
      doc.text(": ", 55, aftertable + afterphoto + 50);
      doc.setFontStyle("bold");

      doc.text(
        "Alam Flora Environmental Solutions Sdn. Bhd. (AFES)",
        55,
        aftertable + afterphoto + 55
      );
      // doc.setFontSize(8);
      // doc.setFontStyle("italic");
      doc.setFontStyle("normal");

      doc.text(
        "(previously known as DRB-HICOM Environmental Services Sdn Bhd)",
        45,
        aftertable + afterphoto + 60
      );
      // doc.setFontSize(11);
      doc.text(
        "Level 2, EON Head Office Complex, 2, Persiaran Kerjaya U1",
        55,
        aftertable + afterphoto + 70
      );
      doc.text(
        "40150 Shah Alam, Selangor Darul Ehsan, MALAYSIA",
        60,
        aftertable + afterphoto + 75
      );
      doc.text(
        "Tel: (603) 7803 0518 Fax: (603) 7809 0137 Web: www.afes.com.my",
        45,
        aftertable + afterphoto + 80
      );

      doc.save("Waste Collection Order.pdf");
    },
    edit() {
      this.wastearray = [];

      this.submit = false;
    },
    saveDraft() {
      let wastearray = [];
      this.wastearray = [];
      this.otherswarning = "";
      let wastecomp = [];
      console.log("hai");

      // checking waste type (should be the same)
      let comp = [];
      console.log(this.tableDatas);
      for (var i = 0; i < this.tableDatas.length; i++) {
        if (comp.indexOf(this.tableDatas[i].nickname) === -1) {
          comp.push(this.tableDatas[i].nickname);
        }
      }

      console.log(comp.length);
      if (comp.length == 1) {
        // check waste type to assign different obj
        let obj = {};
        console.log(this.tableDatas[0].nickname);
        if (
          this.tableDatas[0].nickname == "schedule_waste" ||
          this.tableDatas[0].nickname == "others"
        ) {
          this.tableDatas.forEach((data) => {
            let wastecomp = [];
            if (
              (data.wastetype === "4" && data.swcode === null) ||
              data.swcode === ""
            ) {
              this.modals.warningsubmit = true;
            }

            // if (
            //   data.wastetype === null ||
            //   data.wastetype === "" ||
            //   data.wasteComponents === null ||
            //   data.wasteComponents === "" ||
            //   data.wasteorigin === null ||
            //   data.wasteorigin === "" ||
            //   data.packaging === null ||
            //   data.packaging === "" ||
            //   data.estqty === null ||
            //   data.estqty === "" ||
            //   data.estqtyy === null ||
            //   data.estqtyy === "" ||
            //   data.measurement === null ||
            //   data.measurement === ""
            // ) {
            //   // this.modals.warningsubmit = true;
            // }
            console.log(data.wasteComponents);
            for (var i = 0; i < data.wasteComponents.length; i++) {
              wastecomp.push({ component_name: data.wasteComponents[i].component_name });
            }
            console.log(wastecomp);

            this.wastearray.push({
              waste_type:
                data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
              waste_sub_type: data.wastetype === 1 ? data.swcode : null,
              waste_component: wastecomp,
              waste_source: data.wasteorigin,
              packaging_type: parseInt(data.packaging),
              packaging_quantity: parseInt(data.estqtyy),
              estimate_quantity: parseInt(data.estqty),
              estimate_quantity_unit: data.measurement,
              remarks: data.remarks,
              images: data.images,
            });
          });

          obj = {
            reference_no: this.jobno,
            collection_date: this.collectiondate, // get from first step
            service_location_id: parseInt(this.selects.location),
            service_location_collection_id:
              this.selects.collection == "" ? 0 : this.selects.collection,
            pic_id: this.selects.pic,
            waste: this.wastearray,
          };

          this.$http
            .post(":10001/api/v1/incoming/" + this.jobno + "/draft", obj)
            .then((res) => {
              let response = res.message;

              if (!res.error) {
                console.log("hewo ", response);
                this.submitdraft();
                this.modals.warningsubmit = false;
                this.getSubmittedData();
              } else if (res.error) {
                this.modals.warningsubmit = false;

                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            });
        } else if (this.tableDatas[0].nickname == "garbage") {
          this.tableDatas.forEach((data) => {
            if (
              data.wastetype === null ||
              data.wastetype === "" ||
              data.wasteComponents === null ||
              data.wasteComponents === "" ||
              data.wasteorigin === null ||
              data.wasteorigin === "" ||
              data.packaging === null ||
              data.packaging === "" ||
              data.estqty === null ||
              data.estqty === "" ||
              data.estqtyy === null ||
              data.estqtyy === "" ||
              data.measurement === null ||
              data.measurement === ""
            ) {
              // this.modals.warningsubmit = true;
            }

            for (var i = 0; i < data.wasteComponents.length; i++) {
              wastecomp.push({ component_name: data.wasteComponents[i].component_name });
            }

            wastearray.push({
              waste_type_id:
                data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
              waste_components: wastecomp, //check
              waste_origin: data.wasteorigin,
              packaging_type_id: parseInt(data.packaging),
              packaging_quantity: parseInt(data.estqtyy),
              estimated_quantity: parseInt(data.estqty),
              estimated_quantity_unit: data.measurement,
              remark: data.remarks,
              images: data.images,
              // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
            });
          });

          obj = {
            reference_no: this.jobno,
            collection_date: this.collectiondate, // get from first step
            service_location_id: parseInt(this.selects.location),
            service_location_collection_id:
              this.selects.collection == "" ? 0 : this.selects.collection,
            pic_id: parseInt(this.selects.pic),
            wastes: wastearray,
          };

          console.log("onject", obj);

          this.$http
            .post(
              ":10001/api/v1/incoming/garbage/" + this.jobno + "/draft",
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                if (!res.error) {
                  this.submitdraft();
                  this.modals.warningsubmit = false;
                  this.getSubmittedData();
                } else if (res.error) {
                  this.modals.warningsubmit = false;

                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              }
            });
        } else if (this.tableDatas[0].nickname == "scrap") {
          console.log(" this is scrap !!!");
          this.tableDatas.forEach((data) => {
            console.log(data);
            if (
              data.wastetype === null ||
              data.wastetype === "" ||
              data.wasteComponents === null ||
              data.wasteComponents === "" ||
              data.wasteorigin === null ||
              data.wasteorigin === "" ||
              data.packaging === null ||
              data.packaging === "" ||
              data.estqty === null ||
              data.estqty === "" ||
              data.estqtyy === null ||
              data.estqtyy === "" ||
              data.measurement === null ||
              data.measurement === ""
            ) {
              // this.modals.warningsubmit = true;
            }

            for (var i = 0; i < data.wasteComponents.length; i++) {
              wastecomp.push({ component_name: data.wasteComponents[i].name });
            }

            wastearray.push({
              waste_type_id:
                data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
              waste_components: wastecomp, //check
              waste_origin: data.wasteorigin,
              packaging_type_id: parseInt(data.packaging),
              packaging_quantity: parseInt(data.estqtyy),
              estimated_quantity: parseInt(data.estqty),
              estimated_quantity_unit: data.measurement,
              remark: data.remarks,
              images: data.images,
              // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
            });
          });

          console.log("waste array", this.wastearray);

          obj = {
            reference_no: this.jobno,
            collection_date: this.collectiondate, // get from first step
            service_location_id: parseInt(this.selects.location),
            service_location_collection_id:
              this.selects.collection == "" ? 0 : this.selects.collection,
            pic_id: parseInt(this.selects.pic),
            wastes: wastearray,
          };
          console.log("obj array", obj);

          this.$http
            .post(":10001/api/v1/incoming/scrap/" + this.jobno + "/draft", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                if (!res.error) {
                  console.log("data submit masuk", response);
                  this.submitdraft();
                  this.modals.warningsubmit = false;
                  this.getSubmittedData();
                } else if (res.error) {
                  console.log("data tak masuk");
                  this.modals.warningsubmit = false;

                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              }
            });
        } else if (this.tableDatas[0].nickname == "tyre") {
          console.log(" this is tyre !!!");
          this.tableDatas.forEach((data) => {
            console.log(data);
            if (
              data.wastetype === null ||
              data.wastetype === "" ||
              data.wasteComponents === null ||
              data.wasteComponents === "" ||
              data.wasteorigin === null ||
              data.wasteorigin === "" ||
              data.estqty === null ||
              data.estqty === ""
              // ||
              // data.estqtyy === null ||
              // data.estqtyy === "" ||
              // data.measurement === null ||
              // data.measurement === ""
            ) {
              // this.modals.warningsubmit = true;
            }

            wastearray.push({
              waste_type_id: data.wastetype,
              // !== 4 ? this.newwastetypeid : data.wastetype,
              // waste_components: data.wasteComponents, //check
              waste_origin: data.wasteorigin,
              // packaging_type_id: data.packaging,
              // packaging_quantity: parseInt(data.estqtyy),
              estimated_quantity: parseInt(data.estqty),
              estimated_quantity_unit: "Unit",
              remark: data.remarks,
              images: data.images,
              waste_sub_type_id: data.swcode,
            });
          });

          console.log("waste array", this.wastearray);

          obj = {
            reference_no: this.jobno,
            collection_date: this.collectiondate, // get from first step
            service_location_id: parseInt(this.selects.location),
            service_location_collection_id:
              this.selects.collection == "" ? 0 : this.selects.collection,
            pic_id: this.selects.pic,
            wastes: wastearray,
          };
          console.log("obj array", obj);

          this.$http
            .post(":10001/api/v1/incoming/tyre/" + this.jobno + "/draft", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                if (!res.error) {
                  console.log("data submit masuk", response);
                  this.submitdraft();
                  this.modals.warningsubmit = false;
                  this.getSubmittedData();
                } else if (res.error) {
                  console.log("data tak masuk");
                  this.modals.warningsubmit = false;

                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              }
            });
        }
      } else {
        this.warning = true;
        this.otherswarning = "Waste type must be the same for each row";
      }
    },
    getSubmittedData() {
      this.tableDatas = [];
      this.allfilename = [];
      this.allquodocname = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          this.collectiondate = moment(response.arrival_eta).format(
            "YYYY-MM-DD"
          );
          console.log("heow", response);

          if (
            response.waste_job_document != null &&
            response.waste_job_document.length > 0
          ) {
            this.docs = response.waste_job_document[0].url;
          }

          this.selects.pic = response.pic.user_id;
          // this.selects.location = this.selects.locations[0].value;
          this.selects.location =
            response.service_location_id == 0
              ? ""
              : response.service_location_id;

          setTimeout(() => {
            this.selects.collection = response.service_location_collection_id;
          }, 500);

          this.picsubmitted = response.pic.user_name;
          this.locationsubmitted = response.service_location_name;

          this.phoneno =
            response.pic.user_phone_number == "" ||
              response.pic.user_phone_number == null
              ? "N/A"
              : response.pic.user_phone_number;
          this.faxno =
            response.pic.user_fax_number == "" ||
              response.pic.user_fax_number == null
              ? "N/A"
              : response.pic.user_fax_number;
          this.email = response.pic.user_email;

          let component = [];
          let comp = "";
          var display;
          if (response.waste_detail != null) {
            for (var i = 0; i < response.waste_detail.length; i++) {
              component = [];
              comp = "";
              console.log(response.waste_detail[i].waste_component);
              if (response.waste_detail[i].waste_component != null) {
                for (
                  var j = 0;
                  j < response.waste_detail[i].waste_component.length;
                  j++
                ) {
                  let oo = {
                    id: response.waste_detail[i].waste_component[j]
                      .waste_component_id,
                    component_name: response.waste_detail[i].waste_component[j]
                      .waste_component_name,
                  };
                  component.push(oo);
                }

                // let formattedComponents = component.map(
                //   (item, index) => `${index + 1}. ${item}`
                // );

                // display = formattedComponents;
                // // .join("\r\n");

                // console.log(display);
              }

              let obj = {
                id: i + 1,

                wastetype: response.waste_detail[i].waste_type_id,
                wastetypename: response.waste_detail[i].waste_type_name,

                nickname: response.waste_detail[i].nickname,

                swcode: response.waste_detail[i].waste_type_sub_id,
                swcodename: response.waste_detail[i].waste_type_sub_name,
                swcodes: [],
                packaging: response.waste_detail[i].packaging_type_id,
                packagingname: response.waste_detail[i].packaging_type_name,
                wasteorigin: response.waste_detail[i].waste_source,
                // specifywastetype: "",
                wasteComponents: component,

                estqty: response.waste_detail[i].estimated_quantity,

                estqtyunit: response.waste_detail[i].estimated_quantity_unit,
                measurement: response.waste_detail[i].estimated_quantity_unit,
                estqtyy: response.waste_detail[i].packaging_quantity,
                estqtyyunit: response.waste_detail[i].packaging_type_name,

                remarks: response.waste_detail[i].remarks,
                images: response.waste_detail[i].images,
              };
              this.tableDatas.push(obj);
              this.getSWCode(response.waste_detail[i].waste_type_id, i);
            }
          }

          if (response.waste_job_document != null) {
            for (var i = 0; i < response.waste_job_document.length; i++) {
              let obj = {
                filename: response.waste_job_document[i].meta.filename,
                fileid: response.waste_job_document[i].waste_job_document_id,
                fileurl: response.waste_job_document[i].url,
              };
              this.allfilename.push(obj);
            }
          }

          //get quo docs
          if (response.quotation != null)
            if (response.quotation.quotation_support_document != null) {
              for (
                var i = 0;
                i < response.quotation.quotation_support_document.length;
                i++
              ) {
                let obj = {
                  filename:
                    response.quotation.quotation_support_document[i].filename,
                  fileurl: response.quotation.quotation_support_document[i].url,
                  fileid:
                    response.quotation.quotation_support_document[i]
                      .quotation_support_document_id,
                };
                this.allquodocname.push(obj);
              }
            }

          console.log("here" + this.tableDatas);
        }
      });
    },

    getData() {
      this.load = true;
      this.tableDatas = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;

          this.jobreferenceno = response.reference_number;
          let amountt = 0;
          for (var i = 0; i < response.waste_detail.length; i++) {
            let obj = {
              id: "1",
              description: response.waste_detail[i].waste_type_name,
              rate: response.waste_detail[i].rate,
              estamt: response.waste_detail[i].estimate_quantity,
              amount: response.waste_detail[i].estimate_quantity,
            };
            amountt += response.waste_detail[i].estimate_quantity;
            this.tableDatas.push(obj);
          }
        }
      });
    },

    prevTab() {
      this.$router.push("/Land/Request");
      // let parameter = {
      //   step: "2",
      //   direction: "blkg",
      //   data: [],
      // };
      // this.$emit("my-event", parameter);
    },
    // nextTab() {

    //   let parameter = {
    //     step: "2",
    //     direction: "depan",
    //     data: [],
    //   };
    //   this.$emit("my-event", parameter);
    //   // this.validateStep('step2')
    // },

    handleInput(value) {
      if (value.trim() !== "") {
        this.warning = true;
      }
    },

    handleSpecify(name, row) {
      let obj = {
        name,
      };

      this.$http.post(":10001/api/v1/self/waste-type", obj).then((res) => {
        if (!res.error) {
          let response = res.message;

          this.newwastetypeid = response.waste_type_id;
          this.warning = false;
          //buang button
          row.buttonadd = false;
        } else {
        }
      });
      this.warning = false;
    },

    submitData() {
      this.modals.submit = true;
      setTimeout(() => {
        this.modals.submit = false;
      }, 1500);

      this.submit = true;
      this.getPDF();
    },

    submitdraft() {
      this.modals.drafted = true;
      setTimeout(() => {
        this.modals.drafted = false;

        this.$router.push("/Land/Request");

      }, 1500);



      // this.submit = true;
      // this.getPDF();
    },

    // submitdraft() {
    //   this.modals.drafted = true;
    //   setTimeout(() => {
    //     this.modals.drafted = false;

    //     this.$router.push("/Land/Request");

    //   }, 1500);



    //   // this.submit = true;
    //   // this.getPDF();
    // },

    getNext() { },

    getDeleteRow(row) {
      console.log(row);
      this.tableDatas.splice(row, 1);
      // wastetype
    },

    addRow() {
      let obj = {
        index: this.tableDatas.length,
        id: this.tableDatas.length + 1,
        buttonadd: true,
        wastetype: "",
        swcode: "",
        swcodes: [],
        packaging: "",
        wasteorigin: "",
        wasteComponents: [
          {
            component_name: "",
          },
        ],
        estqty: "",
        estqtyy: "",
        packagingname: "",
        measurement: "",
        remarks: "",
        images: [],
      };

      this.tableDatas.push(obj);
    },

    // submit() {
    //   this.showOverlay = true;
    //   setTimeout(() => {
    //     this.showOverlay = false;
    //     this.wcodone = true;
    //   }, 5000);
    // },
    // onFileChange(event) {
    //   this.uploadload = true;
    //   const t = event.target;
    //   if (t.files.length > 0) {
    //     for (let i = 0; i < t.files.length; i++) {
    //       this.selectedFileName = t.files[i].name;
    //       // this.allfilename.push(this.selectedFileName);
    //     }
    //   } else {
    //     this.selectedFileName = "";
    //   }

    //   this.document = t.files.length;

    //   var input;
    //   if (t.files.length > 0) {
    //     for (let i = 0; i < t.files.length; i++) {
    //       input = this.$refs.file.files[i];
    //       const formData = new FormData();
    //       formData.append("document", input);
    //       this.docs = formData;

    //       this.uploadload = true;
    //       this.buttondisabled = true;

    //       this.$http
    //         .post(
    //           ":10001/api/v1/incoming/" +
    //           this.jobno +
    //           "/upload/upload-waste-job",
    //           this.docs,
    //           {
    //             headers: {
    //               Authorization: `Bearer ${getStorage("token")}`,
    //               "Content-Type": "multipart/form-data",
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           if (!res.error) {
    //             let response = res.message;
    //             this.documentID.push(response.document_id);
    //             this.modals.successModal = true;
    //             this.uploadload = false;

    //             // hmm
    //             this.getSubmittedData();
    //           } else {
    //             console.log("data tak masuk");
    //           }
    //         });

    //       this.buttondisabled = false;
    //     }
    //   }
    // },

    onFileChange(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.selectedFileName = filesArray.map((file) => file.name).join(", ");
        this.document = filesArray.length;

        const uploadPromises = [];

        this.uploadload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          this.buttondisabled = true;

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/upload-waste-job",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.getSubmittedData();
              } else {
                console.log("data tak masuk");
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.uploadload = false;
            this.buttondisabled = false;
            t.value = '';
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.selectedFileName = "";
        this.document = 0;
      }
    },
    // removeFile(indexToRemove) {
    //   // let documentremove = this.documentID[indexToRemove];

    //   // if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
    //   //   this.allfilename.splice(indexToRemove, 1);
    //   //   this.documentID.splice(indexToRemove, 1);
    //   // }

    //   this.$http
    //     .delete(
    //       ":10001/api/v1/incoming/" +
    //       this.jobno +
    //       "/upload/upload-waste-job/" +
    //       indexToRemove
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         this.getSubmittedData();
    //       } else {
    //       }
    //     });
    //   this.$emit("change", null);
    // },

    removeFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/upload-waste-job/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getSubmittedData();
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    submitJobRequest() {
      this.errmsg = "";
      let wastearray = [];
      this.wastearray = [];
      // checking waste type (should be the same)
      let comp = [];
      for (var i = 0; i < this.tableDatas.length; i++) {
        if (comp.indexOf(this.tableDatas[i].nickname) === -1) {
          comp.push(this.tableDatas[i].nickname);
        }
      }

      if (comp.length == 1) {
        let compulsoryitemflag = false;
        // check waste type to assign different obj
        let obj = {};

        if (
          this.tableDatas[0].nickname == "schedule_waste" ||
          this.tableDatas[0].nickname == "others"
        ) {
          this.tableDatas.forEach((data) => {
            // if (
            //   (data.wastetype === "4" && data.swcode === null) ||
            //   data.swcode === ""
            // ) {
            //   this.modals.warningsubmit = true;
            // }

            if (
              // data.wastetype === null ||
              data.wastetype != "" &&
              data.wasteComponents.length != 0 &&
              // data.wasteComponents === "" ||
              // data.wasteorigin === null ||
              data.wasteorigin != "" &&
              // data.packaging === null ||
              data.packaging != "" &&
              // data.estqty === null ||
              data.estqty != "" &&
              // data.estqtyy === null ||
              data.estqtyy != "" &&
              // data.measurement === null ||
              data.measurement != ""
            ) {
              console.log("componentt", data.wasteComponents);
              this.wastearray.push({
                waste_type:
                  data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                waste_sub_type: data.wastetype === 1 ? data.swcode : null,
                waste_component: data.wasteComponents,
                waste_source: data.wasteorigin,
                packaging_type: data.packaging,
                packaging_quantity: parseInt(data.estqtyy),
                estimate_quantity: parseInt(data.estqty),
                estimate_quantity_unit: data.measurement,
                remarks: data.remarks,
                images: data.images,
              });
              compulsoryitemflag = true;
            } else {
              compulsoryitemflag = false;
              this.errmsg = "Please fill all the required data.";
            }
          });

          if (compulsoryitemflag == true) {
            obj = {
              reference_no: this.jobno,
              collection_date: this.collectiondate, // get from first step
              service_location_id: this.selects.location,
              service_location_collection_id:
                this.selects.collection == "" ? 0 : this.selects.collection,
              pic_id: this.selects.pic,
              waste: this.wastearray,
            };

            this.$http
              .post(":10001/api/v1/incoming/" + this.jobno, obj)
              .then((res) => {
                let response = res.message;

                if (!res.error) {
                  console.log("hewo ", obj);
                  this.submitData();
                  this.modals.warningsubmit = false;
                } else if (res.error) {
                  this.modals.warningsubmit = false;

                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              });
          }
        } else

          if (this.tableDatas[0].nickname == "garbage") {
            this.tableDatas.forEach((data) => {
              if (
                // data.wastetype === null ||
                data.wastetype != "" &&
                // data.wasteComponents === null ||
                data.wasteComponents.length != 0 &&
                // data.wasteorigin === null ||
                data.wasteorigin != "" &&
                // data.packaging === null ||
                data.packaging != "" &&
                // data.estqty === null ||
                data.estqty != "" &&
                // data.estqtyy === null ||
                data.estqtyy != "" &&
                // data.measurement === null ||
                data.measurement != ""
              ) {
                wastearray.push({
                  waste_type_id:
                    data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                  waste_components: data.wasteComponents, //check
                  waste_origin: data.wasteorigin,
                  packaging_type_id: parseInt(data.packaging),
                  packaging_quantity: parseInt(data.estqtyy),
                  estimated_quantity: parseInt(data.estqty),
                  estimated_quantity_unit: data.measurement,
                  remark: data.remarks,
                images: data.images,
                  // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
                });
                compulsoryitemflag = true;
              } else {
                compulsoryitemflag = false;
                this.errmsg = "Please fill all the required data.";
              }
            });

            if (compulsoryitemflag == true) {
              obj = {
                reference_no: this.jobno,
                collection_date: this.collectiondate, // get from first step
                service_location_id: this.selects.location,
                service_location_collection_id:
                  this.selects.collection == "" ? 0 : this.selects.collection,
                pic_id: this.selects.pic,
                wastes: wastearray,
              };

              console.log("onject", obj);

              this.$http
                .post(":10001/api/v1/incoming/garbage/" + this.jobno, obj)
                .then((res) => {
                  if (!res.error) {
                    let response = res.message;
                    if (!res.error) {
                      this.submitData();
                      this.modals.warningsubmit = false;
                    } else if (res.error) {
                      this.modals.warningsubmit = false;

                      swal({
                        title: "Data Error!",
                        text: `${res.message}`,
                        type: "warning",
                        confirmButtonClass: "btn btn-success btn-fill",
                        confirmButtonText: "Okay",
                        buttonsStyling: false,
                      });
                    }
                  }
                });
            }
          } else if (this.tableDatas[0].nickname == "scrap") {
            console.log(" this is scrap !!!");
            this.tableDatas.forEach((data) => {
              console.log(data);
              if (
                // data.wastetype === null ||
                data.wastetype != "" &&
                // data.wasteComponents === null ||
                data.wasteComponents.length != 0 &&
                // data.wasteorigin === null ||
                data.wasteorigin != "" &&
                // data.packaging === null ||
                data.packaging != "" &&
                // data.estqty === null ||
                data.estqty != "" &&
                // data.estqtyy === null ||
                data.estqtyy != "" &&
                // data.measurement === null ||
                data.measurement != ""
              ) {
                wastearray.push({
                  waste_type_id:
                    data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                  waste_components: data.wasteComponents, //check
                  waste_origin: data.wasteorigin,
                  packaging_type_id: parseInt(data.packaging),
                  packaging_quantity: parseInt(data.estqtyy),
                  estimated_quantity: parseInt(data.estqty),
                  estimated_quantity_unit: data.measurement,
                  remark: data.remarks,
                  images: data.images,
                  // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
                });
                compulsoryitemflag = true;
              } else {
                compulsoryitemflag = false;
                this.errmsg = "Please fill all the required data.";
              }
            });

            if (compulsoryitemflag == true) {
              console.log("waste array", this.wastearray);

              obj = {
                reference_no: this.jobno,
                collection_date: this.collectiondate, // get from first step
                service_location_id: this.selects.location,
                service_location_collection_id:
                  this.selects.collection == "" ? 0 : this.selects.collection,
                pic_id: this.selects.pic,
                wastes: wastearray,
              };
              console.log("obj array", obj);

              this.$http
                .post(":10001/api/v1/incoming/scrap/" + this.jobno, obj)
                .then((res) => {
                  if (!res.error) {
                    let response = res.message;
                    if (!res.error) {
                      console.log("data submit masuk", response);
                      this.submitData();
                      this.modals.warningsubmit = false;
                    } else if (res.error) {
                      console.log("data tak masuk");
                      this.modals.warningsubmit = false;

                      swal({
                        title: "Data Error!",
                        text: `${res.message}`,
                        type: "warning",
                        confirmButtonClass: "btn btn-success btn-fill",
                        confirmButtonText: "Okay",
                        buttonsStyling: false,
                      });
                    }
                  }
                });
            }
          } else

            if (this.tableDatas[0].nickname == "tyre") {
              console.log(" this is tyre !!!");
              this.tableDatas.forEach((data) => {
                console.log(data);
                if (
                  data.wastetype != "" &&
                  data.swcode != "" &&
                  // data.wasteComponents === null ||
                  // data.wasteComponents.length != 0  &&
                  // data.wasteorigin === null ||
                  data.wasteorigin != "" &&
                  // data.packaging === null ||
                  // data.packaging != "" &&
                  // data.estqty === null ||
                  data.estqty != ""
                  // data.estqtyy === null ||
                  // data.estqtyy != "" &&
                  // data.measurement === null ||
                  // data.measurement != ""
                ) {
                  wastearray.push({
                    waste_type_id: data.wastetype,
                    // data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                    // waste_components: data.wasteComponents, //check
                    waste_origin: data.wasteorigin,
                    // packaging_type_id: data.packaging,
                    // packaging_quantity: parseInt(data.estqtyy),
                    estimated_quantity: parseInt(data.estqty),
                    estimated_quantity_unit: "Unit",
                    remark: data.remarks,
                    images: data.images,
                    waste_sub_type_id: data.swcode,
                  });
                  compulsoryitemflag = true;
                } else {
                  compulsoryitemflag = false;
                  this.errmsg = "Please fill all the required data.";
                }

                console.log(data.wastetype);
              });

              if (compulsoryitemflag == true) {
                console.log("waste array", wastearray);

                obj = {
                  reference_no: this.jobno,
                  collection_date: this.collectiondate, // get from first step
                  service_location_id: this.selects.location,
                  service_location_collection_id:
                    this.selects.collection == "" ? 0 : this.selects.collection,
                  pic_id: this.selects.pic,
                  wastes: wastearray,
                };
                console.log("obj array", obj);

                this.$http
                  .post(":10001/api/v1/incoming/tyre/" + this.jobno, obj)
                  .then((res) => {
                    if (!res.error) {
                      let response = res.message;
                      if (!res.error) {
                        console.log("data submit masuk", response);
                        this.submitData();
                        this.modals.warningsubmit = false;
                      } else if (res.error) {
                        console.log("data tak masuk");
                        this.modals.warningsubmit = false;

                        swal({
                          title: "Data Error!",
                          text: `${res.message}`,
                          type: "warning",
                          confirmButtonClass: "btn btn-success btn-fill",
                          confirmButtonText: "Okay",
                          buttonsStyling: false,
                        });
                      }
                    }
                  });
              }
            }
      } else {
        this.warning = true;
        this.otherswarning = "Waste type must be the same for each row";
      }
    },
    addWasteComponent(index) {
      this.tableDatas[index].wasteComponents.push({ component_name: "" });
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getLocation() {
      this.selects.locations = [];
      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.selects.locations.push(obj);
          }

          // this.selects.location = this.selects.locations[0].value;
        }
      });
    },
    getPIC() {
      this.selects.pics = [];
      this.picdetail = [];

      this.$http.get(":10001/api/v1/self/pic").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].user_name,
              value: response[i].user_id,
              id: response[i].user_id,
              name: response[i].user_name,
              phoneno: response[i].user_phone_number,
              faxno: response[i].user_fax_number,
              email: response[i].user_email,
            };

            this.selects.pics.push(obj);

            // let obj2 = {
            //   id: response[i].user_id,
            //   name: response[i].user_name,
            //   phoneno: response[i].user_phone_number,
            //   faxno: response[i].user_fax_number,
            //   email: response[i].user_email,
            // };

            // this.picdetail.push(obj2);
          }

          this.selects.pic = this.selects.pics[0].value;
        }
      });
    },
    getWasteType() {
      this.selects.wastetypes = [];
      this.$http.get(":10001/api/v1/self/waste-type").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].waste_type_id,
              flag: response[i].nickname,
            };

            this.selects.wastetypes.push(obj);
          }

          // this.selects.wastetype = this.selects.wastetypes[0].value;
        }
      });
    },
    getSWCode(row, index) {
      this.imgmsg = "";
      console.log(row);
      this.selects.swcodes = [];

      let flag = "no";
      let count = 0;
      // for (var i = 0; i < this.tableDatas.length; i++) {
      for (var j = 0; j < this.selects.wastetypes.length; j++) {
        if (
          this.tableDatas[index].wastetype == this.selects.wastetypes[j].value
        ) {
          this.tableDatas[index].nickname = this.selects.wastetypes[j].flag;
          flag = "yes";
          count++;
        }
      }
      console.log(this.tableDatas[index].nickname);

      if (flag == "yes") {
        if (
          this.tableDatas[index].nickname == "schedule_waste" ||
          this.tableDatas[index].nickname == "tyre"
        ) {
          this.$http.get(":10001/api/v1/self/waste-type/" + row).then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.tableDatas[index].swcodes = [];
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  label: response[i].name,
                  value: response[i].waste_type_sub_id,
                };

                this.tableDatas[index].swcodes.push(obj);
                // this.selects.swcodes.push(obj);
              }

              console.log(this.tableDatas[index].swcodes);

              // this.tableDatas[index].swcode = this.selects.swcodes[0].value;
            }
          });
        }
      }

      if (
        this.tableDatas[index].nickname == "garbage" ||
        this.tableDatas[index].nickname == "scrap"
      ) {
        this.wastetype = "noshow";
      }
      if (
        this.tableDatas[index].nickname == "schedule_waste" ||
        this.tableDatas[index].nickname == "tyre" ||
        this.tableDatas[index].nickname == "others"
      ) {
        this.wastetype = "show";
      }

      if (
        this.tableDatas[index].nickname == "tyre" ||
        this.tableDatas[index].nickname == "scrap"
      ) {
        this.wastecomp = "show";
      }

      if (
        this.tableDatas[index].nickname != "tyre" &&
        this.tableDatas[index].nickname != "scrap"
      ) {
        this.wastecomp = "noshow";
      }
      console.log(this.wastetype);
    },
    getPackaging() {
      this.selects.packagings = [];
      this.$http.get(":10001/api/v1/reference/packaging").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].packaging_type_id,
            };

            this.selects.packagings.push(obj);
          }

          // this.selects.packaging = this.selects.packagings[0].value;
          this.selects.packaging = this.selects.packagings[0].value;
        }
      });
    },
    getDatas() {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
        }
      });
    },
    getType2(row) {
      row.packagingname = this.selects.packagings[row.packaging - 1].label;
    },
    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        // this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

/* Add this CSS to your stylesheet */
.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
  /* Ensure there is a vertical scrollbar */
}

/* Webkit browsers (Chrome, Safari) */
.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
